import { Tabs } from '@openeducation/oe-rn-components';
import React from 'react';

import { Card } from '../../atoms/card/card';
import { useAskQuestion } from '../../hooks/use-ask-question';
import { AskATeacher } from '../../molecules/ask-a-teacher/ask-a-teacher';

export interface TeacherFeedbackCardProps {}

export const TeacherFeedbackCard = () => {
  const { questionsCount } = useAskQuestion();

  const askTeacherTitle = `Ask a teacher ${
    questionsCount !== undefined ? `(${questionsCount})` : ''
  }`;

  return (
    <Card title="Teacher Feedback" fullWidth>
      <Tabs>
        <Tabs.Tab id="1" title={askTeacherTitle}>
          <AskATeacher />
        </Tabs.Tab>
        <Tabs.Tab id="2" title="Writing feedback (0)">
          <></>
        </Tabs.Tab>
      </Tabs>
    </Card>
  );
};
